/**
 * AuthContext - 인증 정보 전역 관리
 * 사용자 ID, 타입, 협력사 타입 등을 관리합니다.
 */
import React, { createContext, useState, useContext, useEffect, ReactNode } from 'react';

interface AuthContextType {
    userId: string | null;
    userType: string | null;
    suppType: string;
    isDirectSupplier: boolean;
    setAuth: (newUserId: string, newUserType: string, newSuppType: string) => void; // 동기 함수
    clearAuth: () => void; // 동기 함수
    loading: boolean;
}


const AuthContext = createContext<AuthContextType | undefined>(undefined);

interface AuthProviderProps {
  children: ReactNode;
}

export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  const [userId, setUserId] = useState<string | null>(null);
  const [userType, setUserType] = useState<string | null>(null);
  const [suppType, setSuppType] = useState<string>('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadAuthData();
  }, []);

  const loadAuthData = async () => {
    const userIdValue = localStorage.getItem('USER_ID');
    const userTypeValue = localStorage.getItem('USER_TYPE');
    const suppTypeValue = localStorage.getItem('SUPP_TYPE') || '';

    setUserId(userIdValue);
    setUserType(userTypeValue);
    setSuppType(suppTypeValue);
    setLoading(false);
  };

    const setAuth = (newUserId: string, newUserType: string, newSuppType: string) => {
        localStorage.setItem('USER_ID', newUserId);
        localStorage.setItem('USER_TYPE', newUserType);
        localStorage.setItem('SUPP_TYPE', newSuppType);

        setUserId(newUserId);
        setUserType(newUserType);
        setSuppType(newSuppType);
    };


    const clearAuth = () => {
        localStorage.removeItem('USER_ID');
        localStorage.removeItem('USER_TYPE');
        localStorage.removeItem('SUPP_TYPE');

        setUserId(null);
        setUserType(null);
        setSuppType('');
    };


  const isDirectSupplier = suppType === 'D' || !suppType;

  return (
    <AuthContext.Provider
      value={{
        userId,
        userType,
        suppType,
        isDirectSupplier,
        setAuth,
        clearAuth,
        loading,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};
